module.exports = __webpack_public_path__ + "img/no_notes_icon.8be064f7.svg";